import { Component, OnInit, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { CONFIRM_TRANSLATE_CONTEXT } from '@shared/heplers/const-data';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-pr-success',
    templateUrl: './pr-success.component.html',
    imports: [TranslateModule]
})
export class PrSuccess implements OnInit {
  modalRef = inject(BsModalRef);


  isConfirm: boolean = false;
  message: string;
  ngOnInit() {
  }

  decline(): void {
    this.isConfirm = false;
    this.modalRef.hide();
  }
}
